import { render, staticRenderFns } from "./recordings-list-modal.vue?vue&type=template&id=2089e2be&scoped=true"
import script from "./recordings-list-modal.vue?vue&type=script&lang=js"
export * from "./recordings-list-modal.vue?vue&type=script&lang=js"
import style0 from "./recordings-list-modal.vue?vue&type=style&index=0&id=2089e2be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089e2be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2089e2be')) {
      api.createRecord('2089e2be', component.options)
    } else {
      api.reload('2089e2be', component.options)
    }
    module.hot.accept("./recordings-list-modal.vue?vue&type=template&id=2089e2be&scoped=true", function () {
      api.rerender('2089e2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/recordings-list-modal.vue"
export default component.exports